import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d4567ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-tasks-li__tooltip-content" }, "Добавлено в Очередь для выполнения", -1))

import { PropType, warn, watch } from 'vue';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmPopover,
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { CrossCompactIcon, PlusIcon, StarIcon } from 'tir-style-system/icons/outline';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import { OrderTaskModel, TaskColumnModel, TeammateModel } from '../../models';
import { TaskCard } from '../task-card';
import GetEmployeesWithAccessToProjectItemModel from '@/pages/monitorings/models/GetEmployeesWithAccessToProjectItemModel';
import { useRouter } from 'vue-router';

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'project-task-li',
  props: {
  /**Юзер */
  user: { type: Object as PropType<TeammateModel> },
  /**Отображение иконки со звездой */
  showStar: {
    type: Boolean,
    default: false,
  },
  /**Задача */
  task: {
    type: Object as PropType<OrderTaskModel>,
    required: true,
  },
  /**Колонки */
  columns: {
    type: Array as PropType<Array<TaskColumnModel>>,
    default: () => [],
  },
  /**Настройки видимости */
  viewSettings: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: () => [],
  },
  /**Выбранный исполнитель */
  selectPerformer: { type: Object as PropType<GetEmployeesWithAccessToProjectItemModel> },
  /**Находится в очередности выполнения */
  atExecution: { type: Boolean },
  /**Таблица на странице мониторинга по тикетам */
  monitoringTicketPage: { type: Boolean, default: false },
  /**Скрыть пункты Открыть в шторке и Удалить */
  hideOpenAndDelete: { type: Boolean, default: false },
  /**Расположить статус в левой части таблицы */
  isStatusLeftBlock: { type: Boolean, default: false },
  /**Скрыть иконку у названия */
  hideIconName: { type: Boolean, default: false },
  /**Таблица на странице мониторинга */
  monitoringPage: { type: Boolean, default: false },
},
  emits: ["add", "removeQueue", "openTaskDrawer", "removeTask"],
  setup(__props, { emit }) {

const props = __props;


// #endregion defineProps

// #region defineEmits

// #endregion defineEmits
const removeQueue = () => {
  emit('removeQueue', props.task);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCard), {
    user: __props.user,
    shortInfoParameter: true,
    hideIconName: __props.hideIconName,
    task: __props.task,
    columns: __props.columns,
    "view-settings": __props.viewSettings,
    "slot-left-visible": __props.showStar && __props.atExecution,
    monitoringPage: __props.monitoringPage,
    monitoringTicketPage: __props.monitoringTicketPage,
    selectPerformer: __props.selectPerformer,
    hideOpenAndDelete: __props.hideOpenAndDelete,
    isStatusLeftBlock: __props.isStatusLeftBlock,
    onOpenTaskDrawer: _cache[1] || (_cache[1] = ($event: any) => (emit('openTaskDrawer', $event))),
    onRemoveTask: _cache[2] || (_cache[2] = ($event: any) => (emit('removeTask', $event)))
  }, {
    left: _withCtx(() => [
      _createElementVNode("div", null, [
        (!__props.showStar && __props.task.IsHighlighted)
          ? (_openBlock(), _createBlock(_unref(TirPmButton), {
              key: 0,
              class: "project-tasks-li__button",
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Middle,
              onClick: removeQueue
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CrossCompactIcon), { class: "project-tasks-li__button-icon" }),
                _createTextVNode("1 ")
              ]),
              _: 1
            }, 8, ["variant", "size"]))
          : (__props.showStar && __props.atExecution)
            ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                key: 1,
                width: "max-content"
              }, {
                content: _withCtx(() => [
                  _hoisted_1
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(StarIcon), { class: "project-tasks-li__check-icon" })
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 2,
                class: "project-tasks-li__button",
                variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                size: _unref(TirPmButtonSizeEnum).Middle,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('add', __props.task)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusIcon), { class: "project-tasks-li__button-icon" })
                ]),
                _: 1
              }, 8, ["variant", "size"]))
      ])
    ]),
    _: 1
  }, 8, ["user", "hideIconName", "task", "columns", "view-settings", "slot-left-visible", "monitoringPage", "monitoringTicketPage", "selectPerformer", "hideOpenAndDelete", "isStatusLeftBlock"]))
}
}

})